/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import AccountLoyaltyTile from './account-loyalty-tile';
import AccountLoyaltyTileView from './account-loyalty-tile.view';

export * from './account-loyalty-tile';
export * from './account-loyalty-tile.data';
export {
    IAccountLoyaltyTileConfig,
    IAccountLoyaltyTileProps,
    IAccountLoyaltyTileResources
} from './account-loyalty-tile.props.autogenerated';
export * from './account-loyalty-tile.view';
export * from './components';

export { AccountLoyaltyTile, AccountLoyaltyTileView };
